/**
 * useAgentAnswers - o agente de IA atende este contato?
 *
 * "Responder novos contatos" só vale para contatos NOVOS (2026-10-08): o
 * backend (GET /api/contacts/{chave}/assignment, campo `agent_answers`) sabe
 * se o contato nasceu depois de o modo ser ligado, está na lista ou foi
 * transferido para o agente. O cabeçalho da conversa usa isto para NÃO
 * mostrar o agente como responsável de quem já estava no inbox.
 *
 * Com a flag `autopilot_new_contacts_only` desligada não faz requisição e
 * devolve `true` (comportamento de sempre). COMPARTILHADO pelos 3 shells.
 */
import { useEffect, useState } from 'react';
import assignmentService from '../services/global/assignmentService';
import useFeatureFlags from './useFeatureFlags';

export default function useAgentAnswers(contactKey, refreshKey = 0) {
  const { flags } = useFeatureFlags();
  const enabled = !!flags?.autopilot_new_contacts_only;
  const [answers, setAnswers] = useState(true);

  useEffect(() => {
    if (!enabled || !contactKey) { setAnswers(true); return undefined; }
    let cancelled = false;
    assignmentService.get(contactKey)
      .then((raw) => {
        if (cancelled) return;
        const d = raw?.data ?? raw;
        setAnswers(d?.agent_answers !== false);
      })
      .catch(() => { if (!cancelled) setAnswers(true); });
    return () => { cancelled = true; };
  }, [enabled, contactKey, refreshKey]);

  return enabled ? answers : true;
}
